import { motion } from "framer-motion";
import { ArrowUpRight, Info } from "lucide-react";
import { RevealLines, FadeUp, Overline } from "./Reveal";
import { requestService } from "./scrollUtils";

const PERCORSI = [
  {
    num: "01",
    title: "Percorso Guardaroba",
    tag: "Ottimizzazione dell'Armadio",
    subtitle:
      "Il tuo armadio potenziato con nuove combinazioni di stagione in stagione.",
    desc: "Percorso dedicato a salvare il più possibile di ciò che possiedi già nel tuo armadio per le 4 macro stagioni. Attraverso l'arte dello styling creiamo il maggior numero di outfit possibili con i tuoi capi.",
  },
  {
    num: "02",
    title: "Percorso Shopping",
    tag: "Acquisti Strategici",
    subtitle: "Il mio supporto agli acquisti guidato per tutto l'anno.",
    desc: "4 sessioni di shopping dal vivo distribuite sulle 4 macro stagioni per insegnarti ad acquistare in modo strategico, funzionale e complementare al tuo guardaroba.",
  },
  {
    num: "03",
    title: "Percorso Evolution",
    tag: "Esperienza 360°",
    subtitle: "Guardaroba e Shopping integrati in un unico percorso.",
    desc: "Il percorso annuale ad alto valore trasformativo che unisce 4 sessioni di Restyling Guardaroba dal vivo a 4 sessioni di Shopping strategico, per una trasformazione intensiva e completa.",
  },
];

export const Percorsi = () => {
  return (
    <section
      id="percorsi"
      className="relative py-24 sm:py-36 overflow-hidden"
      data-testid="percorsi-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative z-10">
        <Overline className="mb-8">Percorsi Annuali · Evoluzione a 360°</Overline>
        <h2 className="font-display uppercase text-fuchsiabrand text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl">
          <RevealLines
            lines={[
              <>Ogni trasformazione di <span className="text-espresso">valore</span></>,
              <>richiede <span className="text-espresso">costanza</span> e <span className="text-espresso">continuità</span></>,
            ]}
          />
        </h2>

        <FadeUp delay={0.15}>
          <div className="mt-10 flex items-start gap-4 bg-cipria/25 border border-espresso/10 p-6 max-w-2xl">
            <Info size={22} className="text-fuchsiabrand flex-shrink-0 mt-1" />
            <p className="text-stone leading-relaxed">
              Per accedere ai percorsi è richiesta l'esecuzione preliminare di{" "}
              <span className="text-espresso font-medium">Armocromia</span> e{" "}
              <span className="text-espresso font-medium">Body Shape</span>.
            </p>
          </div>
        </FadeUp>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {PERCORSI.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-8%" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group relative bg-white border border-espresso/10 p-8 pt-10 overflow-hidden hover:border-fuchsiabrand transition-colors duration-500 flex flex-col shadow-[0_18px_50px_-30px_rgba(42,42,42,0.35)]"
              data-testid={`percorso-${p.num}`}
            >
              <span className="absolute -top-6 -right-2 font-display text-[7rem] leading-none text-espresso/[0.06] group-hover:text-fuchsiabrand/10 transition-colors duration-500 select-none">
                {p.num}
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-fuchsiabrand relative z-10">
                {p.tag}
              </span>
              <h3 className="font-display text-2xl text-espresso mt-3 mb-3 leading-tight relative z-10">
                {p.title}
              </h3>
              <p className="font-sans font-semibold text-espresso text-[15px] leading-snug relative z-10 mb-5">
                {p.subtitle}
              </p>
              <p className="text-stone leading-relaxed text-[15px] relative z-10 flex-1">
                {p.desc}
              </p>
              <div className="mt-8 pt-6 border-t border-espresso/10 relative z-10">
                <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-espresso mb-4">
                  Contattami per un preventivo personalizzato
                </p>
                <button
                  onClick={() => requestService(p.title)}
                  data-testid={`percorso-cta-${p.num}`}
                  className="group/btn w-full inline-flex items-center justify-center gap-2 bg-espresso text-crema py-3.5 px-6 rounded-full font-mono text-xs uppercase tracking-[0.15em] hover:bg-fuchsiabrand transition-colors duration-300"
                >
                  Richiedi informazioni
                  <ArrowUpRight size={16} className="group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform duration-300" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
